import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { ApiService }                from '../api/api.service';
import { TableSort }                 from '../table/types/table-sort';
import { TemplatedWordingComponent } from './templated-wording.component';
import { TemplateModel }             from './typings/template';

@Injectable({
  providedIn: 'root'
})
export class TemplatedWordingService {
  private _defaultSortParameters : TableSort = {
    direction: 'asc',
    field    : 'description'
  };

  constructor (
    private apiService  : ApiService,
    private modalService: NgbModal
  ) {}

  addTemplate ( type : string ) : Promise<Array<TemplateModel>> {
    return this.getTemplates(type)
    .then(( templates : Array<TemplateModel> ) => {
      const modal = this.modalService.open(TemplatedWordingComponent, {
        windowClass: 'modal--stacked lg-modal'
      });

      modal.componentInstance.templates = templates;
      modal.componentInstance.type      = type;

      return modal.result;
    });
  }

  getTemplates ( type = 'invoice', params : TableSort = this._defaultSortParameters, filterValue ?: string ) : Promise<Array<TemplateModel>> {
    return this.apiService.get('/templated_wordings', [
      0,
      '*',
      params.field,
      params.direction,
      type,
      filterValue || '*'
    ]);
  }
}

